module.exports = __webpack_public_path__ + "static/img/guide2.ebfb0b23.png";